/**
 * @fileoverview GET handler for the "/api/ecommerce/recommended_events" endpoint
 */
/**
 * @owner @Appboy/user-targeting
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { apiEcommerceRecommendedEvents } from "./constants";
import type { EcommerceRecommendedEventsResponse } from "./types";

export const getApiEcommerceRecommendedEvents = reactQueryFetcherAdapter(
  apiEcommerceRecommendedEvents,
  (signal: AbortSignal): Promise<EcommerceRecommendedEventsResponse> => {
    return fetch("/api/ecommerce/recommended_events", "GET", {}, { signal });
  }
);
